export default function FormInputError({
  id,
  errorMessage,
  isOnlyText = false,
}) {
  return (
    errorMessage && (
      <div
        id={id}
        className={`${
          isOnlyText ? "ui-input-error-only-text" : "ui-input-error"
        }`}
      >
        {errorMessage}
      </div>
    )
  );
}
